import React from 'react';
import { BsLinkedin, BsGithub, BsTwitter} from 'react-icons/bs';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://www.linkedin.com/in/abdellah-hallou/" target="_blank" rel="noreferrer">
        <BsLinkedin color="#0e76a8"/>
        </a>
    </div>
    <div>
          <a href="https://github.com/ABDELLAH-Hallou" target="_blank" rel="noreferrer">
          <BsGithub color="#0e76a8"/>
          </a>
    </div>
    <div>
      <a href="https://twitter.com/HllAbdo" target="_blank" rel="noreferrer">
          <BsTwitter color="#0e76a8"/>
          </a>
    </div>
  </div>
);

export default SocialMedia;
